import { formatElapsed } from '@/helpers/common';
import type { ICustomerPlRowAPI } from '@/types/customerPl';

export class CustomerPlItem {
    public balance: number | null;
    public currencyId: number;
    public curTime: string;
    public groupName: string;
    public groupNameId: number;
    public lastBetAt: string | null;
    public name: string;
    public oddsCloseAvg: number | null;
    public oddsCloseSettledBetCount: number;
    public oddsOpenAvg: number | null;
    public oddsOpenSettledBetCount: number;
    public settledBetCount: number;
    public settledMobileBetCount: number;
    public settledPcBetCount: number;
    public settledStakeSum: number;

    constructor(data: ICustomerPlRowAPI) {
        this.settledBetCount = data.settled_bet_count ?? 0;
        this.settledPcBetCount = data.settled_pc_bet_count ?? 0;
        this.settledMobileBetCount = data.settled_mobile_bet_count ?? 0;
        this.oddsOpenAvg = data.odds_open_avg != null ? Number(data.odds_open_avg) : null;
        this.oddsCloseAvg = data.odds_close_avg != null ? Number(data.odds_close_avg) : null;
        this.oddsOpenSettledBetCount = data.odds_open_settled_bet_count ?? 0;
        this.oddsCloseSettledBetCount = data.odds_close_settled_bet_count ?? 0;
        this.settledStakeSum = data.settled_stake_sum;
        this.balance = data.balance;
        this.curTime = data.cur_time;
        this.lastBetAt = data.last_bet_at;
        this.currencyId = data.currency_id;
        this.name = data.name ?? '';
        this.groupNameId = data.group_name_id;
        this.groupName = data.group_name ?? '';
    }

    get avgBetVsClose(): string {
        if (this.oddsCloseAvg === null || !this.oddsCloseSettledBetCount) return '';
        return `${this.oddsCloseAvg.toFixed(2)} (${this.oddsCloseSettledBetCount})`;
    }

    get avgBetVsOpen(): string {
        if (this.oddsOpenAvg === null || !this.oddsOpenSettledBetCount) return '';
        return `${this.oddsOpenAvg.toFixed(2)} (${this.oddsOpenSettledBetCount})`;
    }

    get avgStake(): number | null {
        if (!this.settledBetCount) return null;
        return this.settledStakeSum / this.settledBetCount;
    }

    get lastBetElapsed(): string {
        return formatElapsed(this.lastBetAt);
    }

    get mobilePercent(): string {
        if (!this.settledBetCount) return '';
        return `${Math.round((this.settledMobileBetCount / this.settledBetCount) * 100)}%`;
    }

    get pcPercent(): string {
        if (!this.settledBetCount) return '';
        return `${Math.round((this.settledPcBetCount / this.settledBetCount) * 100)}%`;
    }

    get roi(): number | null {
        if (this.balance === null || !this.settledStakeSum) return null;
        return (this.balance / this.settledStakeSum) * 100;
    }
}
